module.exports = __webpack_public_path__ + "static/media/ic_group.2a766509.png";